module.exports = __webpack_public_path__ + "img/our1.82e2a5c9.png";